import React, { useEffect,useState, useRef } from 'react';
import '../App.css';
import ListIcons from '../Components/Lib/ListIcons';
import * as R from 'ramda'
import * as api from "../api/apiFunc";
import SvgIcon from '@material-ui/core/SvgIcon';

//import {fetchDict,fetchColu} from './Actions/actions'

const ShowAppToolbar = (props) => {
    const { config, server, filter } = props
    const [curBlock, SetCurBlock] = useState([])
    const [iconsApp, SetIconsApp] = useState([])
    const [inputVal, SetInputVal] = useState('')
  const [inputCont, SetInputCont] = useState('')
  const [width, setWidth] = useState(0);
  const inputElement = useRef();
    useEffect(() => {
        if (api.isEmpty(config.configApp)) return
        SetCurBlock(R.find(R.propEq("block", config.name))(config.configApp)) 
        SetIconsApp(config.iconsApp) 
    }, [config]);
  useEffect(() => {
    if (!inputElement || !inputElement.current) return
    inputElement.current.focus();
    inputElement.current.setSelectionRange(0, 0)
    inputElement.current.blur()
   }, [props.mainfilter])
    
    
  const ComputedAccess = () => {
       const {server} = props
       if (api.isEmpty(config.configApp)) return []
       let curBlock = R.find(R.propEq("block", config.name))(config.configApp)
       if (!(!api.isEmpty(curBlock) && !api.isEmpty(curBlock.children[0]))) return [] 
      //  if (!api.isNotEmptyArr(curBlock) || !api.isNotEmptyArr(curBlock.children[0])) return [] 
        let access = {}  
        curBlock.children[0].icons.map((icon) => {
              const iconapp = R.find(R.propEq('ui_app_icon_id', icon.id))(config.iconsApp)
              switch (iconapp.ui_app_icon_mnem) {
                  case "fulltable": access = {...access, [iconapp.ui_app_icon_mnem]: 1 }
                  break
                  case "fulltableexit": access = {...access, [iconapp.ui_app_icon_mnem]: 1 }
                  break
                  case "save": access = {...access, [iconapp.ui_app_icon_mnem]: 1 }
                  break
                  case "nofilt": access = {...access, [iconapp.ui_app_icon_mnem]: 1  }
                  break
                  case "hide_tables": access = {...access, [iconapp.ui_app_icon_mnem]: 1 }
                  break
                  case "curmarker": access = {...access, [iconapp.ui_app_icon_mnem]: 1 }
                  break
                  case "filter": access = {...access, [iconapp.ui_app_icon_mnem]: 1 }
                  break
                  case "filteroff": access = {...access, [iconapp.ui_app_icon_mnem]: 1 }
                  break
                  case "report": access = { ...access, [iconapp.ui_app_icon_mnem]: /*server && server.StationCode != null ?*/ 1 /*: 0*/ }
                  break
                  case "allmarkers": access = {...access, [iconapp.ui_app_icon_mnem]: 1 }
                  break
                  case "delete": access = {...access,  [iconapp.ui_app_icon_mnem]: 1 }
                  break
              }
        })
        return access  
    }
  /*const setWidth = () => {
      return ((target.value.length < 20 ? event.target.value.length + 1 : 20) * 8) + 'px'
    }*/
    
    const changeHandler = evt => {
      setWidth(evt.target.value.length);
    };
    const ShowFilter = () => {
      const { pick, mainfilter } = props
      if (api.isEmpty(mainfilter) || !api.isNotEmptyArr(pick))
        return null
      let curNazvgruza = ''
      let curKodstdis = ''
      let curNazvstdis = null
      let curNazvpol = ''
      let curNazvotpr = ''
      let curSt = ''
      let curNomv = ''
      let curNapr = ''
      let curDor = ''
      let curActiv = ''
      let curstancPrim = ''
     // const curKodstdis = R.find(R.propEq('name', 'Kodstdis'))(pick).rows 
     // const Kodstdis = R.find(R.propEq('pkid', mainfilter.kodstdis_id))(curKodstdis)
      const Kodstdis = mainfilter.stdis
     // const curVidps = R.find(R.propEq('name', 'Vidp'))(pick).rows 
      const Nazvgruza = mainfilter.nazvgruza
      const Nazvpol = mainfilter.nazvpol
      const Nazvotpr = mainfilter.nazvotpr
      const Nomv = mainfilter.nomv
      const Napr = mainfilter.napr
      const Dor = mainfilter.dor
      const Activ = mainfilter.activ
      const stancPrim = mainfilter.stancprim
      const St = mainfilter.st

      if (!api.isEmpty(Kodstdis)) curKodstdis = `Ст. дисл. = ${Kodstdis};`
      if (!api.isEmpty(Nazvgruza)) curNazvgruza = `Наим. груза = ${Nazvgruza};`
      if (!api.isEmpty(Nazvpol)) curNazvpol = `Получатель = ${Nazvpol};`
      if (!api.isEmpty(Nazvotpr)) curNazvotpr = `Отправитель = ${Nazvotpr};`
      if (!api.isEmpty(Nomv)) curNomv = `Номер вагона = ${Nomv};`
      if (!api.isEmpty(Napr)) curNapr = `Направление = ${Napr};`
      if (!api.isEmpty(Dor)) curDor = `Дорога = ${Dor};`
      if (!api.isEmpty(Activ)) curActiv =`Актив = ${Activ};`
      if (!api.isEmpty(stancPrim)) curstancPrim = `Ст. прим. = ${stancPrim};`
      if (St == 1) curSt = `Станции с грузами = True;`
    
      let cstyle = {width: '8px'}
      const iconapp = R.find(R.propEq('name', 'search'))(config.iconsApp)
      let cont = `${curActiv}  ${curstancPrim} ${curNazvpol} ${curNazvotpr} ${curKodstdis} ${curNazvgruza} ${curNomv} ${curNapr} ${curDor} ${curSt}`
      let str = cont.replace(/\s+/g, ' ').trim()
     // let str1 = `${cont}`.replace('      ', '')
      let clName = str == '' ? "filter-noelem" : "filter-elem"
      return (<div className="filter-cell">
        {/*curActiv && <div  style={cstyle}>
          <input className="filter-elem" style={{width: '50%'}}type="text" placeholder="" value={curActiv} readOnly/>
    </div>*/}
        {<input ref={inputElement} className={clName} style={{ width: width + 'ch', maxWidth: '1200px' }} type="text" value={str} autoFocus={true} onFocus={changeHandler} onChange={changeHandler}/>} 
        {/*{curstancPrim && <div className="filter-elem" style={cstyle}>{curstancPrim}</div>}
        {curNazvpol && <div className="filter-elem" style={cstyle}>{curNazvpol}</div>}
        {curNazvotpr && <div className="filter-elem" style={cstyle}>{curNazvotpr}</div>}
        {curKodstdis && <div className="filter-elem" style={cstyle}>{curKodstdis}</div>}
        {curNazvgruza && <div className="filter-elem" style={cstyle}>{curNazvgruza}</div>}
        {curNomv && <div className="filter-elem" style={cstyle}>{curNomv}</div>}
        {curNapr && <div className="filter-elem" style={cstyle}>{curNapr}</div>}
        {curDor && <div className="filter-elem" style={cstyle}>{curDor}</div>}
    {curSt && <div className="filter-elem" style={cstyle}>{curSt}</div>}*/}
      </div>)
  }

    const FindB = () => {
        //if (!curBlock || !api.isNotEmptyArr(curBlock.children)) return null
        const iconclear = "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"24\" height=\"24\" viewBox=\"0 0 24 24\"><path d=\"M4.25,5.61C6.27,8.2,10,13,10,13v6c0,0.55,0.45,1,1,1h2c0.55,0,1-0.45,1-1v-6c0,0,3.72-4.8,5.74-7.39 C20.25,4.95,19.78,4,18.95,4H5.04C4.21,4,3.74,4.95,4.25,5.61z\"/></svg>"
      const iconapp = R.find(R.propEq('name', 'search'))(config.iconsApp)
      const curicon = curBlock.children[1].icons
        return (<div className="search-cell">
         
          <form>
          <div className="clearable-input">
            <input
              type="text"
              style={{ border: 'none'}}
              value={inputVal}
              onChange={(e) => {SetInputVal(e.target.value) }/* props.handleFilterUpdated*/}
              />
              <span onClick={(e) => { SetInputVal(''); props.handleSeek(curicon[0].id, {arg1:''}) }} data-clear-input>&times;</span>
          </div>
           
            {curBlock.children && curBlock.children[1] &&
              <ListIcons classnam="div-button-menu" classnamsvg='material-button-menu' icons={curBlock.children[1].icons} iconsapp={iconsApp} access={{ "search": 1 }} handleOnClick={props.handleSeek} dopargs={{ arg1: inputVal }}
                server={server} filter={filter}/>}   
            </form>
            
        </div>)
    }
    const access = ComputedAccess() 

    const IconMenuClick = (id) => {
        const iconapp = R.find(R.propEq('ui_app_icon_id', id))(iconsApp)
        switch (iconapp.ui_app_icon_mnem) {
            case "fulltable": props.onHide(); break;
            case "fulltableexit": props.onHide(); break;
            case "nofilt": props.onClearFilter(); break; 
            case "save": props.onSaveData(); /*props.onSaveData();*/ break;
            case "add": props.onInsertRow(); break;
            case "hide_tables": props.onHide(); break;
            case "curmarker": props.setShowAllMarcers(true); break;
            case "allmarkers": props.setShowAllMarcers(false); break;
            case "filter": props.onColumnFilter(); break;
            case "filteroff": props.onColumnFilter(); break;
            case "delete": props.onDeleteRow(); break;
            case "report": props.onGetReport(); break;
        }
     }
     if (api.isEmpty(config.configApp)) return
     let cur_Block = R.find(R.propEq("block", config.name))(config.configApp)
     if (!api.isNotEmptyArr(cur_Block.children) || !api.isNotEmptyArr(iconsApp)) return null 
     
    return (
      <div className="App-toolsbar" /*style = {this.props.config.style}*/>
                {cur_Block.children && cur_Block.children[0] &&
          <ListIcons classnam="div-button-menu" classnamsvg='material-button-menu' filtered={props.filtered} fulltable={props.fulltable} showAllMarcers={props.showAllMarcers} icons={cur_Block.children[0].icons}
            iconsapp={iconsApp} access={access} handleOnClick={IconMenuClick} server={server} filter={filter} />}   
              <div className='server-cell'>
              
                 {ShowFilter()}
              
              
                  {FindB()}
                  </div>
        </div>


    );
}
  
export default ShowAppToolbar
